import React from 'react';
import RagKGApp from '../libs/RagKGApp';

const KnowledgeGraph: React.FC = () => {
  return (
    <div style={{ width: '100%', height: '98%' }}>
      <RagKGApp hashPath="graph-viewer" />
    </div>
  );
};

export default KnowledgeGraph;

